export function encode(component) {
    return component.replace(/[\/\.\$\[\]#!]/g, function (match) { return "!" + match.charCodeAt(0).toString(16).toUpperCase(); });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/firebase-key/dist/key-encode.js
// module id = 2188
// module chunks = 0